<template>
<div class="container">
    <div class="row">
        <div class="col-sm text-start pb-1">
            <span class="badge rounded-pill bg-success pull-left mt-1 py-2 px-4" style="font-size:16px; background:white">
                <b>Groups and users setting : กำหนดกลุ่มและผู้ใช้งานระบบ</b>
            </span>
        </div>
    </div>
    <div class="container">
        <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <button class="nav-link active" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-group" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">แผนก</button>
                <button class="nav-link" id="nav-home-tab" data-bs-toggle="tab" data-bs-target="#nav-users" type="button" role="tab" aria-controls="nav-home" aria-selected="true">รายชื่อผู้ใช้งาน</button>
                <button class="nav-link" id="nav-contact-tab" data-bs-toggle="tab" data-bs-target="#nav-groupauth" type="button" role="tab" aria-controls="nav-contact" aria-selected="false">สิทธิการเข้าใช้งานแยกตามแผนก</button>
            </div>
        </nav>
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-group" role="tabpanel" aria-labelledby="nav-profile-tab">
                <SettingGroups></SettingGroups>
            </div>
            <div class="tab-pane fade" id="nav-users" role="tabpanel" aria-labelledby="nav-home-tab">
                <SettingUsers ></SettingUsers>
            </div>
            <div class="tab-pane fade" id="nav-groupauth" role="tabpanel" aria-labelledby="nav-contact-tab">
                <h3>Lorem, ipsum dolor sit amet consectetur adipisicing elit. Vero, aliquam?</h3>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import SettingUsers from './SettingUsers.vue'
import SettingGroups from './SettingGroups.vue'

export default {
  masks: {
    input: 'YYYY-MM-DD'
  },
  name: 'Setting',
  data () {
    return {

    }
  },
  created () {

  },
  mounted () {

  },
  components: {
    SettingUsers, SettingGroups
  },
  methods: {
  }
}
</script>

<style>

</style>
